import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';

const FontPreview = ({ fontFamily, onSelect }) => {
  return (
    <Paper 
      elevation={1} 
      sx={{ 
        p: 1.5, 
        mb: 1, 
        cursor: 'pointer',
        '&:hover': { 
          bgcolor: 'action.hover',
          transform: 'translateY(-2px)',
          transition: 'all 0.2s ease'
        }
      }}
      onClick={() => onSelect(fontFamily)}
    >
      <Typography variant="subtitle1" sx={{ fontFamily, mb: 0.5 }}>
        {fontFamily}
      </Typography>
      <Typography variant="body2" sx={{ fontFamily, color: 'text.secondary' }}>
        The quick brown fox jumps over the lazy dog
      </Typography>
    </Paper>
  );
};

const FontCategoryPreview = ({ title, fonts, onSelectFont }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 600 }}>
        {title}
      </Typography>
      <Grid container spacing={2}>
        {fonts.map((font) => (
          <Grid item xs={12} sm={6} key={font}>
            <FontPreview fontFamily={font} onSelect={onSelectFont} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const FontsPanel = ({ onSelectFont, fontFamilies }) => {
  // Organize fonts by category
  const modernSansSerif = fontFamilies.slice(0, 22);
  const newModernSansSerif = fontFamilies.slice(22, 33);
  const classicSansSerif = fontFamilies.slice(33, 41);
  const serif = fontFamilies.slice(41, 54);
  const display = fontFamilies.slice(54, 66);
  const monospace = fontFamilies.slice(66);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
        Font Library
      </Typography>
      
      <FontCategoryPreview 
        title="Modern Sans Serif" 
        fonts={modernSansSerif} 
        onSelectFont={onSelectFont} 
      />
      
      <FontCategoryPreview 
        title="New Modern Sans Serif" 
        fonts={newModernSansSerif} 
        onSelectFont={onSelectFont} 
      />
      
      <FontCategoryPreview 
        title="Classic Sans Serif" 
        fonts={classicSansSerif} 
        onSelectFont={onSelectFont} 
      />
      
      <FontCategoryPreview 
        title="Serif" 
        fonts={serif} 
        onSelectFont={onSelectFont} 
      />
      
      <FontCategoryPreview 
        title="Display & Headline" 
        fonts={display} 
        onSelectFont={onSelectFont} 
      />
      
      <FontCategoryPreview 
        title="Monospace" 
        fonts={monospace} 
        onSelectFont={onSelectFont} 
      />
    </Box>
  );
};

export default FontsPanel; 